import { useCallback, useState } from 'react';
import type { UtilsDashData } from '@library/types/utils';

const useUtilDetailsModal = <T extends UtilsDashData>({
  isNewItem,
  defaultItemData,
  modalData,
  onClose,
  reset
}: {
  isNewItem: boolean;
  defaultItemData: T;
  modalData: T;
  onClose: () => void;
  reset: () => void;
}) => {
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [formData, setFormData] = useState<T>(defaultItemData);

  const onClickEdit = useCallback(() => {
    setIsReadOnly(false);
  }, [setIsReadOnly]);

  const onClickClose = useCallback(() => {
    onClose();
    setIsReadOnly(true);
    reset();
  }, [onClose, reset]);

  const handleCancel = useCallback(() => {
    if (isNewItem) {
      onClickClose();
    }
    setIsReadOnly(true);
    setFormData(isNewItem ? defaultItemData : modalData);
    reset();
  }, [isNewItem, defaultItemData, modalData, reset, onClickClose]);

  return {
    formData,
    handleCancel,
    isReadOnly,
    setFormData,
    setIsReadOnly,
    onClickEdit,
    onClickClose
  };
};

export default useUtilDetailsModal;
